import Resume from './Resume';
import './Resume.scss';

export default Resume;
